module.exports = __webpack_public_path__ + "img/linkedin.c1eb2740.svg";